// Zoom history as a contact-sheet strip along the bottom edge — every image
// you've surfaced, newest last. Click a frame to return to it. Keyed on the
// canonical coordinate id (the Phase 2 uniqueness key), not list position.
const Filmstrip = ({ zooms, reload, activeId }) => {
    return (
        <div id="filmstrip">
            <div className="filmstrip-inner">
                {zooms.map((zoom, i) => (
                    <button
                        type="button"
                        key={zoom.id}
                        className={`thumb${zoom.id === activeId ? ' active' : ''}`}
                        onClick={() => reload(zoom)}
                        title={`Specimen ${i + 1}`}
                    >
                        <span className="thumb-index">{i + 1}</span>
                        <img src={zoom.dataUrl} alt={`Zoom ${i + 1}`} />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Filmstrip;
